// Test IDs for the Ragi.design public site.
export const NAV = {
  root: "site-nav-root",
  logo: "site-nav-logo",
  workLink: "site-nav-work",
  servicesLink: "site-nav-services",
  industriesLink: "site-nav-industries",
  aboutLink: "site-nav-about",
  insightsLink: "site-nav-insights",
  contactLink: "site-nav-contact",
  startProject: "site-nav-start-project",
  menuToggle: "site-nav-menu-toggle",
  megaMenu: "site-nav-mega-menu",
};

export const HERO = {
  root: "home-hero",
  headline: "home-hero-headline",
  primaryCta: "home-hero-primary-cta",
  secondaryCta: "home-hero-secondary-cta",
  proofLine: "home-hero-proof-line",
};

export const HOME_SECTIONS = {
  clients: "home-clients",
  manifesto: "home-manifesto",
  work: "home-selected-work",
  services: "home-services",
  founder: "home-founder",
  impact: "home-impact",
  cases: "home-case-studies",
  industries: "home-industries",
  process: "home-process",
  testimonials: "home-testimonials",
  insights: "home-insights",
  team: "home-team",
  cta: "home-cta",
  marquee: "home-marquee",
};

export const FLOATING = {
  bar: "floating-actions-bar",
  whatsapp: "floating-whatsapp",
  email: "floating-email",
  meeting: "floating-meeting",
};

export const FOOTER = {
  root: "site-footer",
  newsletter: "footer-newsletter",
  newsletterInput: "footer-newsletter-input",
  newsletterSubmit: "footer-newsletter-submit",
};

export const CONTACT = {
  form: "contact-form",
  name: "contact-name",
  email: "contact-email",
  company: "contact-company",
  service: "contact-service",
  budget: "contact-budget",
  message: "contact-message",
  submit: "contact-submit",
  success: "contact-success",
};
